import { render } from "./FormulaItems.vue?vue&type=template&id=5ed24678"
import script from "./FormulaItems.vue?vue&type=script&lang=js"
export * from "./FormulaItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__